import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import { useEffect, useState } from "react";

import { Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import classes from '../HeadingComponent.module.css';
import rehypeRaw from 'rehype-raw'
import { useParams } from "react-router-dom";

function BlogContent() {
	const { filename } = useParams();
	const [markdownContent, setMarkdownContent] = useState("");

	useEffect(() => {
		fetch(`/posts/${filename}.md`)
			.then((response) => response.text())
			.then((text) => setMarkdownContent(text));
	}, [filename]);

	return (
		<Container fluid className={classes.container}>
			<div className={classes.headingCard}><Link to="/archive">archive</Link>
</div>
			<Container>
				<ReactMarkdown rehypePlugins={[rehypeRaw]}>{markdownContent}</ReactMarkdown>
			</Container>
		</Container>
		);
	}

export default BlogContent;